/*
 * @Author: yuqiuyu 18180464352@163.com
 * @Date: 2022-07-12 16:41:31
 * @LastEditors: yuqiuyu 18180464352@163.com
 * @LastEditTime: 2022-07-12 16:46:54
 * @FilePath: \vueproject-master\public\api.js
 * @Description:
 * Copyright (c) 2022 by 斯马特有限公司, All Rights Reserved.
 */
var baseUrl;
//判断环境
if (process.env.NODE_ENV == "development") {
  baseUrl = "http://192.168.1.117";
} else if (process.env.NODE_ENV == "prod") {
  baseUrl = "http://192.168.1.117";
} else if (process.env.NODE_ENV == "test") {
  baseUrl = "http://192.168.1.117";
}

let online_url = {
  list: baseUrl + "8022"
};

export default online_url;



//////////////////
// WEBPACK FOOTER
// ./public/api.js
// module id = null
// module chunks = 